import Api from './rest/AgreementApi';

export default new Api();
